import { useEffect, useRef, useState } from 'react'

interface PromptDialogProps {
  open: boolean
  title: string
  label?: string
  defaultValue?: string
  confirmText?: string
  /** e2e selector / DOM id 용. */
  id?: string
  inputId?: string
  confirmButtonId?: string
  onSubmit: (value: string) => void
  onCancel: () => void
}

export function PromptDialog({ open, title, label, defaultValue = '', confirmText = 'Save',
                              id, inputId, confirmButtonId, onSubmit, onCancel }: PromptDialogProps) {
  const [value, setValue] = useState(defaultValue)
  const inputRef = useRef<HTMLInputElement>(null)
  useEffect(() => {
    if (open) {
      setValue(defaultValue)
      setTimeout(() => inputRef.current?.focus(), 0)
    }
  }, [open, defaultValue])
  if (!open) return null
  return (
    <div id={id} className="modal-overlay show active" onClick={onCancel} style={{ display: 'flex' }}>
      <div className="modal" style={{ maxWidth: 420 }} onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">{title}</div>
        <div className="modal-body">
          {label && <label className="form-label" htmlFor={inputId}>{label}</label>}
          <input
            id={inputId}
            ref={inputRef}
            type="text"
            value={value}
            onChange={(e) => setValue(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') { e.preventDefault(); onSubmit(value.trim()) }
              else if (e.key === 'Escape') { e.preventDefault(); onCancel() }
            }}
          />
        </div>
        <div className="modal-footer">
          <button type="button" className="btn btn-ghost" onClick={onCancel}>Cancel</button>
          <button id={confirmButtonId} type="button" className="btn btn-primary"
                  onClick={() => onSubmit(value.trim())}>{confirmText}</button>
        </div>
      </div>
    </div>
  )
}
